import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { StoreProvider } from "./redux/Store";
import './i18n'; //

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <StoreProvider>
    <ToastContainer />
    <App />
  </StoreProvider>
  // </React.StrictMode>
);
